import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SettingsState {
  playNotificationSound: boolean;
  setPlayNotificationSound: (play: boolean) => void;
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      playNotificationSound: true,
      setPlayNotificationSound: (play) => set({ playNotificationSound: play }),
    }),
    {
      name: 'settings-storage',
    }
  )
); 